module.exports = __webpack_public_path__ + "img/food-preference.97eed3a5.svg";